<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';
	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
	}

	let { color = 'gray-900', title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} {...rest}>
	<path
		d="M3 7L6 8.73205L6 5.26795L3 7ZM21 7L18 5.26795L18 8.73205L21 7ZM5.7 7.3L18.3 7.3L18.3 6.7L5.7 6.7L5.7 7.3Z"
		fill={getTailwindColor(color)}
	/>
	<path
		d="M4 18.8125H20M4.27586 19L4.27586 13M19.7241 19V13M12 19V13M8.13793 19V15.25M15.8621 19V15.25"
		stroke={getTailwindColor(color)}
	/>
</SvgWrapper>
